export const storeId = 'next-gen/backlog-filters-state';

export const TEXT = 'TEXT' as const;
export const ASSIGNEE = 'ASSIGNEE' as const;
export const LABEL = 'LABEL' as const;
export const ISSUE_PARENT = 'ISSUE_PARENT' as const;
export const ISSUE_TYPE = 'ISSUE_TYPE' as const;
export const VERSION = 'VERSION' as const;
export const CUSTOM_FILTER = 'CUSTOM_FILTER' as const;

export const QUERY_PARAM_TEXT = 'text' as const;
export const QUERY_PARAM_SEARCH = 'search' as const;
export const QUERY_PARAM_ASSIGNEE = 'assignee' as const;
export const QUERY_PARAM_LABEL = 'label' as const;
export const QUERY_PARAM_ISSUE_PARENT = 'issueParent' as const;
export const QUERY_PARAM_ISSUE_TYPE = 'issueType' as const;
export const QUERY_PARAM_VERSION = 'version' as const;
export const QUERY_PARAM_CUSTOM_FILTER = 'customFilter' as const;
export const QUERY_PARAM_QUICK_FILTER = 'quickFilter' as const;
